const state = {
  staffs: [],
  currentPage: null,
  lastPage: null,
  nextPage: null,
  prevPage: null,
  total: null,
  from: 1,
  to: 100,
  showActionMessage: false,
  actionMessageEdit: null,
  cancelActionMessageEdit: false,
  messageEditCurrentListChat: null,
  statusEdit: false,
  listMessage: [],
  listTags: [],
  listUnreadMessage: [],
  listUnreadByStaff: [],
  lastStaffMessage: null,
  listNewStaffMessage: [],
  listReceptionMessages: [],
  listFakeMessage: []
}

const getters = {
  // begin staff
  staffs (state) {
    return state.staffs
  },
  currentPage (state) {
    return state.currentPage
  },
  lastPage (state) {
    return state.lastPage
  },
  nextPage (state) {
    return state.nextPage
  },
  prevPage (state) {
    return state.prevPage
  },
  total (state) {
    return state.total
  },
  from (state) {
    return state.from
  },
  to (state) {
    return state.to
  },
  // end staff

  // begin message
  listMessage (state) {
    return state.listMessage
  },
  showActionMessage (state) {
    return state.showActionMessage
  },
  actionMessageEdit (state) {
    return state.actionMessageEdit
  },
  cancelActionMessageEdit (state) {
    return state.cancelActionMessageEdit
  },
  statusEdit (state) {
    return state.statusEdit
  },
  messageEditCurrentListChat (state) {
    return state.messageEditCurrentListChat
  },
  listUnreadMessage (state) {
    return state.listUnreadMessage
  },
  listUnreadByStaff (state) {
    return state.listUnreadByStaff
  },
  lastStaffMessage (state) {
    return state.lastStaffMessage
  },
  listNewStaffMessage (state) {
    return state.listNewStaffMessage
  },
  listReceptionMessages (state) {
    return state.listReceptionMessages
  },
  listFakeMessage (state) {
    return state.listFakeMessage
  },
  // end message

  // begin tags
  listTags (state) {
    return state.listTags
  },
  getTagById: (state) => (userId) => {
    return state.listTags.find(tag => tag.userId === userId)
  }
  // end tags
}

const mutations = {
  SET_STAFFS (state, staffs) {
    state.staffs = staffs
  },
  SET_CURRENT_PAGE (state, currentPage) {
    state.currentPage = currentPage
  },
  SET_LAST_PAGE (state, lastPage) {
    state.lastPage = lastPage
  },
  SET_NEXT_PAGE (state, nextPage) {
    state.nextPage = nextPage
  },
  SET_PREV_PAGE (state, prevPage) {
    state.prevPage = prevPage
  },
  SET_TOTAL (state, total) {
    state.total = total
  },
  SET_FROM (state, from) {
    state.from = from
  },
  SET_TO (state, to) {
    state.to = to
  },
  SET_LIST_MESSAGE (state, listMessage) {
    state.listMessage = listMessage
  },
  SET_LAST_STAFF_MESSAGE (state, staffMessage) {
    state.lastStaffMessage = staffMessage
  },
  SET_LIST_UNREAD_MESSAGE (state, message_id = '') {
    if (message_id !== '') {
      const index = state.listUnreadMessage.findIndex(value => value === message_id)
      if (index === -1) {
        state.listUnreadMessage = [...state.listUnreadMessage, message_id]
      }
    } else {
      state.listUnreadMessage = []
    }
  },
  SET_LIST_UNREAD_BY_STAFF (state, data = null) {
    if (data && data.staff_id && data.action) {
      const index = state.listUnreadByStaff.findIndex(value => value === data.staff_id)
      if (index === -1 && data.action === 'add') {
        state.listUnreadByStaff = [...state.listUnreadByStaff, data.staff_id]
      }
      if (index !== -1 && data.action === 'remove') {
        state.listUnreadByStaff = [...state.listUnreadByStaff.slice(0, index), ...state.listUnreadByStaff.slice(index + 1)]
      }
    } else {
      state.listUnreadByStaff = []
    }
  },
  SET_LIST_NEW_STAFF_MESSAGE (state, data = null) {
    if (data && data.current_time && data.message_id) {
      const index = state.listNewStaffMessage.findIndex(value => value.message_id === data.message_id)
      if (index === -1 && !data.action) {
        state.listNewStaffMessage = [...state.listNewStaffMessage, data]
      } else if (index !== -1 && data.action && data.action === 'REMOVE') {
        state.listNewStaffMessage = [...state.listNewStaffMessage.slice(0, index), ...state.listNewStaffMessage.slice(index + 1)]
      }

      state.listNewStaffMessage = JSON.parse(JSON.stringify(state.listNewStaffMessage.filter(e => e.current_time > data.current_time - 60 * 1000)))
    } else {
      state.listNewStaffMessage = []
    }
  },
  SET_ACTION_MESSAGE (state, statusShow) {
    state.showActionMessage = statusShow
  },
  SET_ACTION_MESSAGE_EDIT (state, messageEdit) {
    state.actionMessageEdit = messageEdit
  },
  SET_CANCEL_ACTION_MESSAGE_EDIT (state, status) {
    state.cancelActionMessageEdit = status
  },
  SET_STATUS_EDIT (state, status) {
    state.statusEdit = status
  },
  SET_MESSAGE_EDIT_CURRENT (state, mess) {
    state.messageEditCurrentListChat = mess
  },
  SET_LIST_TAGS (state, tag) {
    const index = state.listTags.findIndex(e => e.userId === tag.userId)
    if (index === -1) {
      state.listTags = [...state.listTags, tag]
    } else {
      state.listTags[index] = tag
    }
  },
  REMOVE_FROM_LIST_TAGS (state, userId) {
    state.listTags = state.listTags.filter((tag) => {
      return tag.userId !== userId
    })
  },
  SET_LIST_RECEPTION_MESSAGES(state, listReceptionMessages) {
    state.listReceptionMessages = listReceptionMessages
  },
  SET_LIST_FAKE_MESSAGE(state, listFakeMessage) {
    state.listFakeMessage = listFakeMessage
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
